import { faPen } from '@fortawesome/free-solid-svg-icons';

import { Icon } from '../Icon';
import type { CustomIconProps } from './types';

/**
 * Renders a Edit (pen) icon with an optional badge.
 *
 * @see Docs https://fontawesome.com/icons/pen?f=classic&s=solid
 */
export const EditIcon: React.FC<CustomIconProps> = (props) => {
  return <Icon icon={faPen} {...props} />;
};
